import { useCartContext } from '@/app/contexts/CartProvider';
import useDisplayAffirm from '@/app/hooks/useDisplayAffirm';
import useFeatureFlag from '@/app/hooks/useFeatureFlag';
import type { Products_content_listProducts_discountedPrice } from '@/queries/types/Products';

import isAccessory from '../_utils/isAccessory';
import isFreeRing from '../_utils/isFreeRing';

/**
 * Returns whether or not affirm messaging should be displayed on the PDP
 * */
const useShowPDPAffirmMessage = (
  discountedProductPrice:
    | Products_content_listProducts_discountedPrice
    | undefined,
  handle: string | undefined,
): boolean => {
  const isEnabledUSOnly = useDisplayAffirm();
  const cartContext = useCartContext();
  const showAffirmMultiRing = useFeatureFlag('show-affirm-multi-ring');
  const refreshCart = cartContext?.refreshCart;
  const cart = refreshCart?.data?.cart;
  const ringCount = cart?.ringCount ?? 0;

  if (!discountedProductPrice || !handle) return false;

  const isFree = isFreeRing(discountedProductPrice);
  const isRing = !isAccessory(handle);
  const hasRings = ringCount > 0;

  return (
    !isFree && isRing && isEnabledUSOnly && (showAffirmMultiRing || !hasRings)
  );
};

export default useShowPDPAffirmMessage;
